export default __webpack_public_path__ + "locales/en/DataReassignmentDialog.json?hash=00c271bfc5184455cbe394fd8fce2115";